import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, sessionExpired } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const message = sessionExpired
      ? 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.'
      : 'Zugriff verweigert. Bitte melden Sie sich an um fortzufahren';
    return <Navigate to="/login" state={{ from: location, message }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
